import { Component, Input } from '@angular/core';
import { ProgressSpinnerKind } from '@sb/library/base';

@Component({
    selector: 'lib-widget-progress-spinner',
    templateUrl: './widget-progress-spinner.component.html',
    styleUrls: ['./widget-progress-spinner.component.scss']
})
export class WidgetProgressSpinnerComponent {

    private _progressValue: number = 0;
    private _value!: number;

    @Input()
    set value(value: number) {
        this._progressValue = 0;
        this._value = value;
        this.Step();
    }

    @Input() diameter: number = 100;
    @Input () kind: ProgressSpinnerKind = ProgressSpinnerKind.Determinate;

    private Step(): void {
        if (this._progressValue === this._value) {
            return;
        }
        this._progressValue++;
        requestAnimationFrame(this.Step.bind(this));
    }

    get progressValue(): number {
        return this._progressValue;
    }

}
